export default "__VITE_ASSET__AV$e9qXD__"